<template>
<div>
<v-card style="width:100%;height:50px" class="secondary">
     <v-layout row wrap style="height:40px;">
      <v-flex xs12 style="padding-top:8px" >
      <input type="text" style="float:left;width:200px;"  v-model="search"  class="search" placeholder="Search All Column" >
         <v-btn class="success searchbtn" @click="fetchstatement"> Search</v-btn>
    <v-menu
        :close-on-content-click="false"
        v-model="menu2"
        lazy
        transition="scale-transition"
        offset-y
        style="float:right"
        >
         <input type="text" slot="activator"  v-model="date2" readonly class="search" placeholder="To Date" >
        <v-date-picker v-model="date2" @input="menu2 = false"></v-date-picker>
      </v-menu>
    <v-menu
        :close-on-content-click="false"
        v-model="menu1"
        lazy
        transition="scale-transition"
        offset-y
        style="float:right"
        >
         <input type="text" slot="activator"  v-model="date1" readonly class="search" placeholder="From Date" >
        <v-date-picker v-model="date1" @input="menu1 = false"></v-date-picker>
      </v-menu>
      </v-flex>
    </v-layout>
</v-card>
<v-data-table
      :headers="headers"
      :items="statementlist"
      :search="search"
      hide-deta
      hide-default-header
      class="payout-report"
    >
     <template  v-slot:header="{ props: { headers } }">
        <thead>            
          <tr>
            <th v-for="(h,i) in headers" :key="i"  class="text-capitalize">
                {{h.text}}
            </th>
          </tr>
        </thead>
      </template>
      <template slot="items" slot-scope="props">
      
        <td v-for="(val,i) in props.item" :key="i">
           <template v-if="i === 'action'">
              <v-btn @click="checkStatus(props.item)" depressed color="primary">Check Status</v-btn>
           </template>
            <template v-else>
               {{ val }} 
            </template>
            </td>
      </template>
    </v-data-table>

  <v-dialog v-model="dialog" persistent width="300"><v-card color="primary" dark><v-card-text>Please wait <v-progress-linear indeterminate  color="white" class="mb-0"/></v-card-text></v-card></v-dialog>
</div>
</template>


<script>
export default {
   data(){
      return{
            headers: [ ],
            dialog:false,
            statementlist:[],
            modal:false,
            search:'',
            date1:'',
            menu1:false,
            date2:'',
            menu2:false,
      }
   },
   computed:{
      user(){
         return this.$store.getters.user;
      }
   },
   methods:{
     notification(type,message){
        this.$notify({
                group: 'foo',
                title: 'Important message',
                text: message,
                duration:5000,
                type:type
        })
      },
      pushstatement(value){
         let vm = this;
         vm.statementlist = []
         value.forEach(item => {
             delete item.response
             item.action = ''
             vm.statementlist.push(item);
         })
         if(value.length !== 0 && vm.headers.length === 0) {
             Object.keys(value[0]).forEach(key => {
                 let name = key.split("_").join(" ");
                 if(key !== "response") vm.headers.push({ text: name, value: key })
             }) 
         }

      },
      fetchstatement(){
         let vm = this;
         if(!vm.user.phone) return vm.notification("warn","Authentication Required!");
         let doc = {
           'MobileNo':vm.user.phone,
           'Password':vm.user.password,
           'AuthKey':vm.user.authkey,
           'getFromdate':vm.date1,
           'getTodate':vm.date2,
           'Source':'json'
           }
            vm.dialog = true;
            vm.$store.dispatch("axiospost",{
                  url:"View_PayOut_Transactions",
                  data:doc,
            }).then(function (res) {
                  vm.dialog = false;
                  vm.pushstatement(res.data)
            }).catch(function (error) {
                  vm.notification("error",error.message);
                  vm.dialog = false;
            })
      },
      checkStatus({txid}){
         let vm = this;
         if(!vm.user.phone) return vm.notification("warn","Authentication Required!");
         let doc = {
           'MobileNo':vm.user.phone,
           'Password':vm.user.password,
           'AuthKey':vm.user.authkey,
           'TxId':txid,
           'Source':'json'
           }
            vm.dialog = true;
            vm.$store.dispatch("axiosdmrpost", {
                  type: "mink",
                  url:"MinksPay_Transaction_Status",
                  data:doc,
            }).then(function (res) {
               vm.$root.alert(res.data.message)
               vm.dialog = false;
            }).catch(function (error) {
                  vm.notification("error",error.message);
                  vm.dialog = false;
            })
      }
   },
   mounted(){
      let vm = this;
      vm.fetchstatement()
   }
}
</script>

<style scoped>
.search{
   width:150px;
   float: right;
   margin-right: 10px;
   height: 34px;
   background: white;
   outline:none;
   margin-left:20px;
   padding-left:10px;
   font-size:1em;
}

.searchbtn{
   margin-right:15px;
   height: 34px;
   margin-left:20px;
   float: right;
   margin-top:0px;
}
</style>
<style >
.payout-report .v-table__overflow  th{
    text-transform: capitalize;
}

</style>
